import { Modal } from "components";
import { type ISystemOneModalProps } from "components/modal";
import React from "react";
import { Button, Message } from "semantic-ui-react";

interface Permission {
  hasPermission: boolean
  permissionName: string
}

interface Props extends ISystemOneModalProps {
  permission: Permission | Permission[]
}

const PermissionCheckModal = (props: React.PropsWithChildren<Props>) => {
  const { permission, ...rest } = props;

  const permissions = Array.isArray(props.permission) ? props.permission : [props.permission];

  const permissionsWithNoAccess = permissions.filter(p => !p.hasPermission);

  if (permissionsWithNoAccess.length > 0) {
    return <Modal {...rest} title={RESX.SoUser.Permissions}>
      <div className="grow1">
        <Message color="red">
          <div className="margin-bottom-small">{RESX.ExceptionMessage.YouHaveInsufficientAccess}</div>
          <ul>{
            permissionsWithNoAccess.map(p => (<li key={p.permissionName}>{p.permissionName}</li>))
          }
          </ul>
        </Message>
      </div>

      <div className="flex justify-end">
        <div><Button primary onClick={() => { props.handleClose(); }}>{RESX.Buttons.BtnOk}</Button></div>
      </div>
    </Modal>;
  }

  return <Modal
    {...rest}
  >
    {props.children}
  </Modal>;
};

export default PermissionCheckModal;